import { DateTime } from 'luxon';

import { IsoDateString } from 'types';

import { DATE_FORMAT } from './dates';

/**
 * Formats the PTO granted date from form values.
 * If the reviewer has marked the EPC-submitted date as incorrect and provided a corrected date,
 * uses the corrected date. Otherwise, uses the regular PTO granted date.
 *
 * @param values - Formik form values containing PTO date fields
 * @returns ISO date string or undefined
 */
export const formatPtoGrantedDate = (values: {
  isEpcPtoDateIncorrect?: boolean;
  qcCorrectedPtoDate?: string;
  ptoGrantedDate?: string;
}): IsoDateString | undefined => {
  // If during review, reviewer has decided the PTO date is incorrect, use the corrected date
  if (values.isEpcPtoDateIncorrect && values.qcCorrectedPtoDate) {
    return (DateTime.fromFormat(values.qcCorrectedPtoDate, DATE_FORMAT).toISODate() as IsoDateString) || undefined;
  }

  // Otherwise, use the regular PTO granted date
  if (values.ptoGrantedDate) {
    return (DateTime.fromFormat(values.ptoGrantedDate, DATE_FORMAT).toISODate() as IsoDateString) || undefined;
  }

  return undefined;
};
